/**
 * Hero Barbería — orquesta la secuencia:
 * el logo entra desde el centro entre brasas doradas -> se desplaza junto al
 * texto -> texto aparece -> ya asentado, respira/se balancea/le brilla el ojo
 * y sigue levemente al ratón (inclinación 3D).
 * Funciona con varias instancias de la sección y se relanza en el editor de temas.
 */
(function () {
  'use strict';

  var PREFERS_REDUCED_MOTION =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_HOVER = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var EMBER_COUNT = 26;

  function initHeroBarber(section) {
    if (!section || section.dataset.hbInitDone === 'true') return;
    section.dataset.hbInitDone = 'true';

    var logoLayer = section.querySelector('[data-hb-logo-layer]');
    var logoWrap = section.querySelector('[data-hb-logo-wrap]');
    var tilt = section.querySelector('[data-hb-tilt]');
    var embersHost = section.querySelector('[data-hb-embers]');
    var lines = section.querySelectorAll('[data-hb-line]');

    if (!logoWrap) return;

    var speed = parseFloat(getComputedStyle(section).getPropertyValue('--hb-anim-speed')) || 1;
    if (!speed || isNaN(speed)) speed = 1;

    var TIMING = {
      startDelay: 250 * speed,
      splashDuration: 900 * speed,
      pauseAfterSplash: 500 * speed,
      settleDuration: 1000 * speed,
      lineStagger: 100 * speed
    };

    function buildEmbers() {
      if (!embersHost) return;
      embersHost.innerHTML = '';
      for (var i = 0; i < EMBER_COUNT; i++) {
        var e = document.createElement('span');
        e.className = 'hero-barber__ember';
        var angle = Math.random() * Math.PI * 2;
        var radius = 55 + Math.random() * 85;
        var ex = Math.cos(angle) * radius;
        var ey = Math.sin(angle) * radius + 30; // sesgo hacia abajo, como si ascendieran
        e.style.setProperty('--hb-ex', ex.toFixed(1) + 'px');
        e.style.setProperty('--hb-ey', ey.toFixed(1) + 'px');
        e.style.animationDelay = Math.round(Math.random() * 160 * speed) + 'ms';
        embersHost.appendChild(e);
      }
    }

    function playEmbers() {
      if (!embersHost) return;
      buildEmbers();
      requestAnimationFrame(function () {
        embersHost.querySelectorAll('.hero-barber__ember').forEach(function (e) {
          e.classList.add('is-going');
        });
      });
    }

    function computeSettleTransform() {
      var heroRect = section.getBoundingClientRect();
      var splashSize = logoWrap.offsetWidth;
      var style = getComputedStyle(section);

      var isMobile = window.innerWidth < 750;

      var finalSize = isMobile
        ? parseFloat(style.getPropertyValue('--hb-logo-final-size-m'))
        : parseFloat(style.getPropertyValue('--hb-logo-final-size'));
      if (!finalSize || isNaN(finalSize)) finalSize = splashSize;

      var finalXPct = parseFloat(style.getPropertyValue(isMobile ? '--hb-logo-final-x-m' : '--hb-logo-final-x'));
      var finalYPct = parseFloat(style.getPropertyValue(isMobile ? '--hb-logo-final-y-m' : '--hb-logo-final-y'));
      if (isNaN(finalXPct)) finalXPct = 50;
      if (isNaN(finalYPct)) finalYPct = 50;

      var scale = finalSize / splashSize;
      var dx = heroRect.width * (finalXPct / 100 - 0.5);
      var dy = heroRect.height * (finalYPct / 100 - 0.5);

      return (
        'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(' + scale + ')'
      );
    }

    function applySettlePosition(withTransition) {
      if (!withTransition) {
        logoWrap.style.transition = 'none';
      }
      logoWrap.classList.add('is-settling');
      logoWrap.style.transform = computeSettleTransform();
      if (!withTransition) {
        // Forzar reflow para que el "transition: none" surta efecto antes de restaurarlo
        void logoWrap.offsetHeight;
        logoWrap.style.transition = '';
      }
    }

    function revealLines() {
      lines.forEach(function (line, i) {
        setTimeout(function () {
          line.classList.add('is-visible');
        }, i * TIMING.lineStagger);
      });
    }

    function onResize() {
      if (logoWrap.classList.contains('is-settling')) {
        applySettlePosition(false);
      }
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onResize, 120);
    });

    // ---- Inclinación 3D: el ángel gira levemente siguiendo al ratón ----
    if (tilt && HAS_HOVER && !PREFERS_REDUCED_MOTION) {
      section.addEventListener('mousemove', function (e) {
        var rect = section.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        var maxTilt = 10;
        tilt.style.transform =
          'rotateY(' + (relX * maxTilt).toFixed(2) + 'deg) rotateX(' + (relY * -maxTilt).toFixed(2) + 'deg)';
      });
      section.addEventListener('mouseleave', function () {
        tilt.style.transform = 'rotateY(0deg) rotateX(0deg)';
      });
    }

    // ---- Modo "sin animación" para accesibilidad ----
    if (PREFERS_REDUCED_MOTION) {
      logoWrap.classList.add('is-visible');
      applySettlePosition(false);
      lines.forEach(function (line) {
        line.classList.add('is-visible');
      });
      return;
    }

    // ---- Secuencia animada completa ----
    setTimeout(function () {
      logoWrap.classList.add('is-visible');
      playEmbers();

      setTimeout(runSettle, TIMING.splashDuration + TIMING.pauseAfterSplash);
    }, TIMING.startDelay);

    function runSettle() {
      applySettlePosition(true);
      revealLines();
      setTimeout(function () {
        logoWrap.classList.add('is-idle');
      }, TIMING.settleDuration);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hero-barber]').forEach(initHeroBarber);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Relanzar la animación cuando se edita/añade la sección desde el Editor de temas
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-hero-barber]');
    if (section) {
      section.dataset.hbInitDone = 'false';
      initHeroBarber(section);
    }
  });
})();